import { AGENT_HTTP } from "./agentUrl";

export async function provisionVolume(token: string, volumeId: string, sizeBytes: number): Promise<void> {
  if (!token || !sizeBytes) return;                 // create emits size 0 → skip
  await fetch(`${AGENT_HTTP}/volume?token=${encodeURIComponent(token)}`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ volumeId, size: sizeBytes }),
  }).catch(() => { /* provisioning is best-effort; the block write already persisted */ });
}
